export const API_ENDPOINTS = {
  VERIFY_EMAIL: "/auth/verify-email?token=:token",
  resetPassword: "/auth/reset-password",
  SEND_ACCOUNT_DELETION: "/notifications/send-email-deletion",

};
